import * as React from "react";
import Grid from "@mui/material/Grid";
import TopBar from "../../components/TopBar/TopBar";
import { LayoutPage } from "../../components/Layout/layoutPage";
import { Button, IconButton, Pagination, Typography } from "@mui/material";
import ArchiveIcon from "@mui/icons-material/Archive";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState, useRef } from "react";
import { ModalEdit } from "../../components/Modal/ModalEdit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { connect, useDispatch, useSelector } from "react-redux";
import translate from "../../i18n/messages/translate";
import { I18n } from "../../i18n";
import useSWR from "swr";
import Loading from "../../components/Loading/loading";
import _ from "lodash";
import FirstPreventivo from "./firstPreventivo";
import CartellaPreventivi from "./cartellaPreventivi";
import CustomizedSnackbars from "../../components/Message/Snackars";
import ClientiForm from "../../components/Formik/clientiForm";
import PaginationButton from "../../components/Paginazione/PaginationButton";
import { useParams } from "react-router";
import { importBaseActions } from "../../store/reducers/base";
import { usePaginationStyles } from "../../core/MuiStyles";
//Breadcrumbs
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from "@mui/icons-material/Home";
import {useNavigationStack} from "../../v2/providers/NavigationContext";
const NewPreventivo = () => {
  const state = useSelector(state => state.base);
  const baseActions = importBaseActions();
  const dispatch = useDispatch();

  //const history = useHistory();
  const navigate = useNavigate();  
  const classes = usePaginationStyles();
  //filtrare
  const [filter, setFilter] = useState({ searchText: "" });
  const timerRef = useRef(null);
  const { stack, goToStack } = useNavigationStack();
  const { push } = useNavigationStack();
  //
  const [paginationModel, setPaginationModel] = React.useState({
    page: 1,
    pageSize: 10,
  });

  const [open, setOpen] = useState(false);
  const location = useLocation();
  const handleClick = () => setOpen(true);
  const [openEdit, setOpenEdit] = useState(false);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  let axiosConfig = {
    headers: {
      Authorization: "Bearer " + state.user.token,
    },
  };

  // const fetcher = (url) =>
  //   axios
  //     .post(url, { id: count.id, page: page }, axiosConfig)
  //     .then((res) => res.data.data);
  // const { data, error } = useSWR(
  //   [`${process.env.REACT_APP_API_URL}/quote`, count.success, page],
  //   fetcher
  // );


  useEffect(() => {
    dispatch(baseActions.clearStorage());
    load();
  }, [paginationModel]);

  useEffect(() => {
    dispatch(baseActions.clearStorage());
    setData(null);
    setPaginationModel({...paginationModel, page: 1});
  }, [state.customer]);
  useEffect(() => {
    dispatch(baseActions.clearStorage());
      load();
    }, [filter]);
  const load = async (page) => {
    try
    {
      console.log(location.state?.id)
      let res = await axios.post(`${process.env.REACT_APP_API_URL}/quote?v=2`, { id: location.state?.id ?? state.user.id, page: paginationModel.page, pageSize: paginationModel.pageSize,searchText: encodeURI(filter.searchText),isRetail: location.state?.isRetail }, axiosConfig);
      if (res.data.success !== 1) throw res.data.message;
      console.log(res.data);
      setData(res.data.data);
    }
    catch (e)
    {
      console.error(e);
      setError(e);
    }
  }

  const getBackUrl = () => {
    if (!state.customer.isServiceCustomer) return "/clienti";

    let destination = "/configurations";
    return destination;
  }

  if (error) {
    return <div>failed to load</div>;
  }
  const performSearch = (searchText) => {
    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    timerRef.current = setTimeout(() => {
      setFilter({ searchText });
    }, 600);
  };

  return (
    <I18n locale={state.locale}>
      <LayoutPage>
        <div style={{flex: "0 0 auto"}}>
        <TopBar />
        <div className={"d-flex justify-content-between p-3"}>
          <div className="d-flex flex-column" style={{ lineHeight: "1" }}>
            <h2 className="h2 fw-bold">{translate("Preventivi")}</h2>
            <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="breadcrumb">
                      {stack.slice().reverse().map((item, index) => {
                        const isLast = index === stack.length - 1;
                        const isFirst = index === 0;

                        return (
                          <Typography
                            key={index}
                            onClick={() => {
                              if (!isLast) goToStack(index);
                            }}
                            sx={{
                              cursor: isLast ? "default" : "pointer",
                              color: isFirst ? "#df5b23" : isLast ? "text.primary" : "#212529",
                              textDecoration: isLast ? "none" : "underline",
                              display: "flex",
                              alignItems: "center",
                              '&:hover': {
                                textDecoration: isLast ? "none" : "underline",
                              },
                            }}
                          >
                            {isFirst ? (
                              <>
                                <HomeIcon style={{ width: "1.1rem", height: "1.2rem", marginRight: 4 }} />
                                Home
                              </>
                            ) : (
                              item.label
                            )}
                          </Typography>
                        );
                      })}
                </Breadcrumbs>
            </div>
          </div>
          <div>
            <button className="btn btn-primary" type="button" onClick={() => {
                if(!state.user.isCustomer){
                  navigate("/select-customer")
                }else{
                  dispatch(baseActions.clearStorage());
                  navigate("/products", { state: { id: state.user.id } });
                }
              }}>
              <AddIcon />
              {translate("NUOVO_PREVENTIVO")}
            </button>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center p-3">
          <div className="d-flex align-items-center p-1" style={{ flexBasis: "30%", minWidth: "200px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="digita per iniziare la ricerca"
              onInput={(e) => performSearch(e.currentTarget.value)}
            />
          </div>
          <span className="badge rounded-pill bg-success">totale configurazioni: {data && data.total}</span>
        </div>
        <ModalEdit
          title={"Modifica cliente"}
          open={openEdit}
          handleClose={handleCloseEdit}>
          <ClientiForm handleClose={handleCloseEdit} user={state.customer ? state.customer.id : state.user.id} />
        </ModalEdit>
      </div>
      <div style={{ flex: "1 1 auto", overflowY: "auto" }}>
        <div className="px-3 pb-3">
          {!data ? (
                <Loading />
              ) : (_.isEmpty(data.data) === true && filter == "") ? (
                <FirstPreventivo />
              ) : (_.isEmpty(data.data) === true && filter !== "") ? (
                  <div className="flex items-center justify-center h-64">
                    <span className="text-gray-500 text-xl font-semibold">
                      Nessuna Configurazione
                    </span>
                  </div>
              ) : (
                <CartellaPreventivi data={data.data} />
              )
          }
          {data && data.total > 0 && (
            // <PaginationButton
            //   page={page}
            //   setPage={setPage}
            //   lastPage={data.last_page}
            // />
            <Pagination
              className={classes.root}
              style={{flexDirection: "row-reverse"}}
              color="primary"
              count={Math.ceil(data.total / paginationModel.pageSize)}
              page={paginationModel.page}
              onChange={(event, value) => setPaginationModel({...paginationModel, page: value})}
            />
          )}
        </div>
      </div>
      </LayoutPage>
    </I18n>
  );
};

export default NewPreventivo;
